export default {
  content_url: 'https://content.api.delfi.lt/content/v3/graphql',
};
